import React, { useState,useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { formatDate } from './Function';
import { usePage } from '../PageContext';
import ResearchGate from '../assets/images/ResearchGate.png';
import OrcId from '../assets/images/OrcId.png';
import Scopis from '../assets/images/Scopis.png';
import Vidwan from '../assets/images/Vidwan.png';
import GoogleScholar from '../assets/images/GoogleScholar.png';
import { Row,Col,Card,Accordion,ListGroup,Placeholder,Image } from 'react-bootstrap';

const FacultyDetails = ({htaccess}) => 
{
    const { currentPage } = usePage();
    const { t } = useTranslation();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Profiles,setProfiles]=useState([]);
    useEffect(()=>
    {
        const ProfileDetails = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"faculty/details/"+htaccess);
                const result = await response.json();
                if( result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.su_id + "/suPhoto")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "userFields/all")
                                .then(ufs => ufs.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, ufs]) => {
                                    return {
                                        ...e,
                                        upp,
                                        ufs
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].suPhoto = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].suFields = (el.ufs.length > 0) ? el.ufs : [];
                        });
                        setProfiles(result);
                        currentPage(result[0]);
                        setLoading(false);
                    }).catch(error => 
                    {
                        console.error('FormsSearch File :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setProfiles([]);
                    setLoading(false);            
                }
                if( global.config.IsPrint === false ) { console.info('ProfileDetails : Result',result); }
            } catch (error)
            {
                console.error('ProfileDetails : Error', error.message);
                setLoading(false);
            }
        };
        ProfileDetails();
        // eslint-disable-next-line
    },[htaccess])
    return (
        <React.Fragment>
        {isLoading ? (
            <Row>
                <Col md={3}>
                    <Card>
                        <Card.Header className='fs-3 text-center'>
                            {appLanguage === 'hi' ? "प्रोफ़ाइल" : "Profile"}
                        </Card.Header>
                        <Card.Body className='text-center'>
                            <Placeholder className="rounded-circle border border-3 mb-3" style={{width:"128px",height:"128px"}} />
                            <Card.Title><Placeholder xs={10} /></Card.Title>
                            <Card.Text><Placeholder xs={12} /></Card.Text>
                            <h6 className='text-start border-bottom pb-2'>{appLanguage === 'hi' ? "सम्पर्क विवरण" : "Contact Details"}</h6>
                            {[...Array(5)].map((_,index)=>(
                            <div className='text-start mb-3' key={index}>
                                <span className='float-start me-2 border rounded-circle d-flex align-items-center justify-content-center' style={{width:"30px",height:"30px"}}>
                                    <Placeholder xs={6} />
                                </span>
                                <div><Placeholder xs={10} /></div>
                            </div>
                            ))}
                        </Card.Body>                           
                    </Card>
                </Col>
                <Col md={9}>
                    <Card className='mb-4'>
                        <Card.Header className='fs-4 text-uppercase'><Placeholder xs={10} /></Card.Header>
                        <Card.Body>
                            {[...Array(10)].map((_,index)=>(
                            <Card key={index} className='border-0'>
                                <Card.Header className='bg-success-subtle rounded text-uppercase'><Placeholder xs={5} /></Card.Header>
                                <Card.Body>
                                    <Placeholder xs={10} />
                                    <Placeholder xs={12} />
                                    <Placeholder xs={7} />
                                </Card.Body>
                            </Card>
                            ))}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        ) : (
            <React.Fragment>
            {Profiles.map((Profile,index)=>(
            <Row key={index}>
                <Col md={3}>
                    <Card className='mb-3'>
                        <Card.Header className='fs-3 text-center'>
                            {appLanguage === 'hi' ? "प्रोफ़ाइल" : "Profile"}
                        </Card.Header>
                        <Card.Body className='text-center'>
                            {Profile.suPhoto && <Image src={Profile.suPhoto} className="rounded-circle border border-3 mb-3" style={{width:"128px",height:"128px"}} />}
                            <Card.Title>{appLanguage === 'hi' ? Profile.su_name_hi || Profile.su_name : Profile.su_name}</Card.Title>
                            <Card.Text><SetDetails suId={Profile.su_id} ufId={2} /></Card.Text>
                            <h6 className='text-start border-bottom pb-2'>{appLanguage === 'hi' ? "सम्पर्क विवरण" : "Contact Details"}</h6>
                            <div className='w-100 d-flex text-start mb-3'>
                                <span className='float-start me-2 border rounded-circle d-flex align-items-center justify-content-center' style={{minWidth:"30px",height:"30px"}}>
                                    <i className="bi bi-telephone"></i>
                                </span>
                                <div><SetDetails suId={Profile.su_id} ufId={4} /></div>
                            </div>
                            <div className='w-100 d-flex text-start mb-3'>
                                <span className='me-2 border rounded-circle d-flex align-items-center justify-content-center' style={{minWidth:"30px",height:"30px"}}>
                                    <i className="bi bi-envelope-fill"></i>
                                </span>
                                <div><SetDetails suId={Profile.su_id} ufId={5} /></div>
                            </div>
                            <div className='w-100 d-flex text-start mb-3'>
                                <span className='me-2 border rounded-circle d-flex align-items-center justify-content-center' style={{minWidth:"30px",height:"30px"}}>
                                    <i className="bi bi-geo-alt"></i>
                                </span>
                                <div><SetDetails suId={Profile.su_id} ufId={3} /></div>
                            </div>
                            <div className='w-100 d-flex text-start mb-3'>
                                <span className='me-2 border rounded-circle d-flex align-items-center justify-content-center' style={{minWidth:"30px",height:"30px"}}>
                                    <i className="bi bi-globe"></i>
                                </span>
                                <div className='text-break'><SetDetails suId={Profile.su_id} ufId={6} /></div>
                            </div>
                            <div className='w-100 d-flex align-items-center justify-content-end mb-3'>
                                <SetLinks suId={Profile.su_id} ufId={15} src={ResearchGate} alt={t('ResearchGateAlt')} />
                                <SetLinks suId={Profile.su_id} ufId={11} src={OrcId} alt={t('OrcIdAlt')} />
                                <SetLinks suId={Profile.su_id} ufId={18} src={Scopis} alt={t('ScopisAlt')} />
                                <SetLinks suId={Profile.su_id} ufId={13} src={Vidwan} alt={t('VidwanAlt')} />
                                <SetLinks suId={Profile.su_id} ufId={16} src={GoogleScholar} alt={t('GoogleScholar')} />
                            </div>
                        </Card.Body>                           
                    </Card>
                </Col>
                <Col md={9}>
                    <Card className='mb-4'>
                        <Card.Header className='fs-4'>
                            {appLanguage === 'hi' ? Profile.departments.sd_fullname_hi || Profile.departments.sd_fullname : Profile.departments.sd_fullname} {appLanguage === 'hi' ? Profile.userType.ut_name_hi || Profile.userType.ut_name : Profile.userType.ut_name} {appLanguage === 'hi' ? "प्रोफ़ाइल" : "Profile"}
                        </Card.Header>
                        <Card.Body>
                            <Accordion defaultActiveKey="0" alwaysOpen>
                            {Profile.suFields
                            .filter((field) => [1,8,9,21,22,23,24,25,26,27].includes(field.uf_id))
                            .map((Fields,index)=>(
                                <Accordion.Item eventKey={index.toString()} key={index}>
                                    <Accordion.Header>{appLanguage === 'hi' ? Fields.uf_name_hi || Fields.uf_name : Fields.uf_name}</Accordion.Header>
                                    <Accordion.Body>
                                        <FieldsDetails suId={Profile.su_id} Fields={Fields} />
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                            </Accordion>
                        </Card.Body>
                    </Card>
                    <JournalPapers suId={Profile.su_id} htaccess={htaccess} />
                    <ConferencePapers suId={Profile.su_id} htaccess={htaccess} />
                </Col>
            </Row>
            ))}
            </React.Fragment>
        )}
        </React.Fragment>
    );
}
export default FacultyDetails;
const FieldsDetails = ({suId,Fields}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[Details,setDetails]=useState([]);
    useEffect(()=>
    {
        const getDetails = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"userDetails/byUserField/"+suId+"/"+Fields.uf_id);
                const result = await response.json();
                setDetails(result);
                if( global.config.IsPrint === true ) { console.info('FieldsDetails : Result',result); }
              
            } catch (error) 
            {
                console.error('FieldsDetails : Error', error.message);
            }
        };
        getDetails();    
    },[suId,Fields])
    return (
        <React.Fragment>
        {Details.map((ud,index)=>{
            if(Fields.uf_id === 15 || Fields.uf_id === 16 || Fields.uf_id === 19) 
            {
                return <a key={index} href={ud.ud_details}>{ud.ud_details}</a>;
            }
            else
            {
                return <div key={index} dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? ud.ud_details_hi : ud.ud_details}} />;
            }            
        })}
        </React.Fragment>
    );
}
const SetDetails = ({suId,ufId}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[Details,setDetails]=useState([]);
    useEffect(()=>
    {
        const getDetail = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"userDetails/byUserField/"+suId+"/"+ufId);
                const result = await response.json();
                setDetails(result);
                if( global.config.IsPrint === true ) { console.info('Details : Result',result); }
              
            } catch (error) 
            {
                console.error('Details : Error', error.message);
            }
        };
        getDetail();    
    },[suId,ufId])
    return (
        <React.Fragment>
        {Details.map((ud,index)=> 
        {
            if(ufId === 5) 
            {
                return <a key={index} href={'mailto:'+ud.ud_details}>{ud.ud_details}</a>;
            }
            else if (ufId === 6) 
            {
                return <a key={index} href={ud.ud_details}>{ud.ud_details}</a>;
            } 
            else 
            {
                return <span key={index}>{appLanguage === 'hi' ? ud.ud_details_hi : ud.ud_details}</span>;
            }           
        })}
        </React.Fragment>
    );
}
const SetLinks = ({suId,ufId,src,alt}) => 
{
    const[Details,setDetails]=useState([]);
    const[isLoading,setLoading]=useState(true);
    useEffect(()=>
    {
        const getDetail = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"userDetails/byUserField/"+suId+"/"+ufId);
                const result = await response.json();
                setDetails(result);
                if( global.config.IsPrint === true ) { console.info('Links : Result',result); }
                
            } catch (error) 
            {
                console.error('Links : Error', error.message);
            }
            setLoading(false);
        };
        getDetail();    
    },[suId,ufId])
    return (
        <React.Fragment>
        {isLoading ? (
            <Placeholder style={{width:"34px",height:"34px"}} />
        ) : (
            <React.Fragment>
            {Details.map((ud,index)=> 
            {
                return <a key={index} href={ud.ud_details} className='mx-1' target="_blank" rel="noopener noreferrer" aria-label={alt}>
                            <Image fluid src={src} alt={alt} width={34} height={34} />
                        </a>;           
            })}
            </React.Fragment>
        )}        
        </React.Fragment>
    );
}
const JournalPapers = ({suId,htaccess}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[JournalTotal, setJournalTotal] = useState(0);
    const[Journals,setJournal]=useState([]);
    useEffect(()=>
    {
        const JournalByUserLatest = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"journal/list/"+suId+"/0/5");
                const result = await response.json();
                setLoading(false);
                setJournal(result);
                if( global.config.IsPrint === true ) { console.info('JournalByUserLatest : Result',result); }
            } catch (error) 
            {
                console.error('JournalByUser : Error', error.message);
            }
        };
        JournalByUserLatest();
        const JournalCount = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"journal/list/"+suId+"/0/1000");
                const result = await response.json();
                setJournalTotal(result.length);
            } catch (error) 
            {
                console.error('JournalByUserAll : Error', error.message);
            }
        };
        JournalCount();
    },[suId,htaccess])
    function stripTags(html) {
        return html.replace(/<\/?[^>]+(>|$)/g, "");
    }
    return (
        <Card className='mb-4'>
            <Card.Header className='fs-4 text-uppercase'>
                {appLanguage === 'hi' ? "जर्नल पेपर्स" : "Journal Papers"}
            </Card.Header>
            <Card.Body>
            {isLoading ? (
                <ListGroup variant="flush">
                    {[...Array(10)].map((_,index)=>(
                    <ListGroup.Item key={index} className='px-0'>
                        <span className="me-1"><Placeholder xs={1} /></span>
                        <span className="me-1"><Placeholder xs={3} /></span>
                        <span className="fw-bold me-1"><Placeholder xs={7} /></span>
                        <span className="me-1"><Placeholder xs={4} /></span>
                        <span className="me-1"><Placeholder xs={3} /></span>
                        <span className="me-1"><Placeholder xs={2} /></span>
                        <span className="me-1"><Placeholder xs={3} /></span>
                        <span className="me-1"><Placeholder xs={4} /></span>                        
                    </ListGroup.Item>
                    ))}
                </ListGroup>
                ) : (                
                <ListGroup variant="flush">
                {Journals.map((sj,index)=>(
                    <ListGroup.Item key={index} className='px-0'>
                        <span className="fw-bold me-1">J.{JournalTotal - index.toString()}</span>
                        <span className="me-1">{(sj.sj_authors_hi || sj.sj_authors) && (appLanguage === 'hi' ? sj.sj_authors_hi || sj.sj_authors : sj.sj_authors) + ','}</span>
                        <span className="fw-bold me-1">{(sj.sj_name_hi || sj.sj_name) && (appLanguage === 'hi' ? sj.sj_name_hi || sj.sj_name : sj.sj_name) + ','}</span>
                        <span className="me-1" dangerouslySetInnerHTML={{ __html: (sj.sj_description_hi || sj.sj_description) && stripTags( appLanguage === 'hi' ? sj.sj_description_hi || sj.sj_description : sj.sj_description ) + ',' }}></span>
                        <span className="me-1">{sj.sj_volume && sj.sj_volume +','}</span>
                        <span className="me-1">{sj.sj_page_no && sj.sj_page_no + ','}</span>
                        <span className="me-1">{sj.sj_date && formatDate(sj.sj_date)}</span>                        
                    </ListGroup.Item>
                ))}
                </ListGroup>
            )}
            <NavLink to={appLanguage === 'hi' ? `/प्रोफ़ाइल/प्रकाशन/${htaccess}` : `/profile/publications/${htaccess}`} className='btn btn-info float-end' target='_blank' rel="noopener noreferrer" data-aos="flip-up" data-aos-duration="1000">
                {appLanguage === 'hi' ? 'सभी को देखें' : 'View All'} ({JournalTotal})
            </NavLink>
            </Card.Body>
        </Card>
    );
}
const ConferencePapers = ({suId,htaccess}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[ConferenceTotal, setConferenceTotal] = useState(0);
    const[Conferences,setConference]=useState([]);
    useEffect(()=>
    {
        const ConferenceByUserLatest = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"conference/list/"+suId+"/0/5");
                const result = await response.json();                
                setLoading(false);
                setConference(result);
                if( global.config.IsPrint === true ) { console.info('ConferenceByUserLatest : Result',result); }
            } catch (error) 
            {
                console.error('ConferenceByUser : Error', error.message);
            }
        };
        ConferenceByUserLatest();
        const ConferenceCount = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"conference/list/"+suId+"/0/1000");
                const result = await response.json();
                setConferenceTotal(result.length);
            } catch (error) 
            {
                console.error('ConferenceCount : Error', error.message);
            }
        };
        ConferenceCount();
    },[suId,htaccess])
    function stripTags(html) {
        return html.replace(/<\/?[^>]+(>|$)/g, "");
    }
    return (
        <Card className='mb-4'>
            <Card.Header className='fs-4 text-uppercase'>
                {appLanguage === 'hi' ? "सम्मेलन पेपर्स" : "Conference Papers"}
            </Card.Header>
            <Card.Body>
            {isLoading ? (
                <ListGroup variant="flush">
                {[...Array(10)].map((_,index)=>(
                <ListGroup.Item key={index} className='px-0'>
                    <span className="me-1"><Placeholder xs={1} /></span>
                    <span className="me-1"><Placeholder xs={3} /></span>
                    <span className="fw-bold me-1"><Placeholder xs={7} /></span>
                    <span className="me-1"><Placeholder xs={4} /></span>
                    <span className="me-1"><Placeholder xs={3} /></span>
                    <span className="me-1"><Placeholder xs={2} /></span>
                    <span className="me-1"><Placeholder xs={3} /></span>
                    <span className="me-1"><Placeholder xs={4} /></span>
                </ListGroup.Item>
                ))}
                </ListGroup>
                ) : (                    
                <ListGroup variant="flush">
                {Conferences.map((sc,index)=>(
                    <ListGroup.Item key={index} className='px-0'>
                        <span className="fw-bold me-1">C.{ConferenceTotal - index.toString()}</span>
                        <span className="me-1">{(sc.sc_author_hi || sc.sc_author) && (appLanguage === 'hi' ? sc.sc_author_hi || sc.sc_author : sc.sc_author) + ','}</span>
                        <span className="fw-bold me-1">{(sc.sc_name_hi || sc.sc_name) && (appLanguage === 'hi' ? sc.sc_name_hi || sc.sc_name : sc.sc_name) + ','}</span>
                        <span className="me-1" dangerouslySetInnerHTML={{ __html: (sc.sc_description_hi || sc.sc_description) && stripTags( appLanguage === 'hi' ? sc.sc_description_hi || sc.sc_description : sc.sc_description ) + ',' }}></span>
                        <span className="me-1">{(sc.sc_publisher_hi || sc.sc_publisher) && (appLanguage === 'hi' ? sc.sc_publisher_hi || sc.sc_publisher : sc.sc_publisher) + ','}</span>
                        <span className="me-1">{sc.sc_pages && sc.sc_pages +','}</span>
                        <span className="me-1">{(sc.sc_venue_hi || sc.sc_venue) && (appLanguage === 'hi' ? sc.sc_venue_hi || sc.sc_venue : sc.sc_venue) + ','}</span>
                        <span className="me-1">{sc.sc_date && formatDate(sc.sc_date)}</span>                        
                </ListGroup.Item>
                ))}
                </ListGroup>
            )}
            <NavLink to={appLanguage === 'hi' ? `/प्रोफ़ाइल/प्रकाशन/${htaccess}` : `/profile/publications/${htaccess}`} className='btn btn-info float-end' target='_blank' rel="noopener noreferrer" data-aos="flip-up" data-aos-duration="1000">
                {appLanguage === 'hi' ? 'सभी को देखें' : 'View All'} ({ConferenceTotal})
            </NavLink>
            </Card.Body>
        </Card>
    );
}
